'use client'
import Image from 'next/image'
import Link from 'next/link'
import { getBrandNameFormat } from '@/utils/brandFormat'

interface Props {
  data: any
}

export const ProductGridItem = ({ data }: Props) => {
  // console.log('data', data)

  let localSrc = `/imgs/placeholder.webp`
  if (data.productImages.length) {
    localSrc = data.productImages[0].url
  }

  const { brand, category } = data.categoryBrand
  const { productSize, productWidth, productHeight } = data.productAtrr
  const srcBrand = getBrandNameFormat(brand)

  return (
    <div className="rounded-lg overflow-hidden border border-gray-300 bg-white fade-in w-[18rem] mx-auto">
      <div className="bg-custom-blue h-[0.5rem]"></div>
      <div className="flex flex-row justify-center">
        <Image
          src={`/marcas/${srcBrand}`}
          alt={brand.name}
          width={173}
          height={90}
        />
      </div>
      <div className="flex flex-row justify-center">
        {category.name} - {brand.name}
      </div>
      <div className="p-6 flex flex-col">
        <Link
          className="hover:text-blue-600 text-l font-bold mb-2"
          href={`/product/${data.slug}`}
        >
          <div className="flex flex-col">
            <div className="font-light">
              Rodado: <span className="font-bold">{productSize?.value}</span>
            </div>
            <div className="font-light">
              Alto: <span className="font-bold">{productHeight?.value}</span>
            </div>
            <div className="font-light">
              Ancho: <span className="font-bold">{productWidth?.value}</span>{' '}
            </div>
            <div>
              Precio:
              <span className="text-1xl text-blue-800"> ${data.price}</span>
            </div>
          </div>
        </Link>
      </div>

      {/* Imagen del producto */}
      <Link href={`/product/${data.slug}`}>
        <div className="flex justify-center items-center p-4">
          <div className="w-full h-[300px] relative overflow-hidden">
            <Image
              src={localSrc}
              alt={brand.name}
              className="object-contain w-full h-full rounded-lg transition-transform duration-200 hover:scale-105"
              width={300}
              height={300}
            />
          </div>
        </div>
      </Link>

      {/* Botón de más detalles */}
      <div className="relative mt-4">
        <Link
          href={`/product/${data.slug}`}
          className="block w-full px-4 py-2 bg-blue-600 text-white font-bold rounded-none hover:bg-blue-800 hover:scale-105 transition-all duration-300 text-center border-t border-gray-300 z-10"
        >
          Más detalles
        </Link>
        <div className="absolute top-0 left-0 w-full h-[2px] bg-blue-800"></div>
      </div>
    </div>
  )
}
